module.exports = __webpack_public_path__ + "static/media/geographic.61c41d4b.svg";